import(/* webpackMode: "eager" */ "/github/workspace/src/app/[locale]/merchants/page.tsx");
